export const formatPrice = (price: number | string): string => {
    return `${price
        .toString()
        .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')} ₽`;
};
